/* GASSISA
=========================================================================================
 * Descripcion: Catalogos (campos, labels y separadores) del layout de ticket por caja,
 *              normalizacion de objetos y valores de impresion por seccion. Modulo puro
 *              compartido entre el disenador (FrmParametrosCaja) y la impresion ESC/POS.
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 17/10/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion
 * ---------------------------------------------------------------------------------------*/

export const CAMPOS_DETALLE = [
    { campo: "descripcion", etiqueta: "Descripción", muestra: "Blusa manga corta color rosa talla M", anchoMm: 50, altoMm: 8, multilinea: true },
    { campo: "cantidad", etiqueta: "Cantidad", muestra: "2" },
    { campo: "medida", etiqueta: "Talla", muestra: "M" },
    { campo: "costounitario", etiqueta: "P.Unit", muestra: "199.00" },
    { campo: "descuento", etiqueta: "Desc", muestra: "0.00" },
    { campo: "total", etiqueta: "Importe", muestra: "398.00" },
    { campo: "vendedorpreventa", etiqueta: "Vendedor", muestra: "Nadia" },
    { campo: "almacenexhibidor", etiqueta: "Origen", muestra: "Piso" },
    { campo: "abono", etiqueta: "Abono", muestra: "300.00" },
    { campo: "ivaabono", etiqueta: "IVA abono", muestra: "48.00" },
];

export const LABELS_DETALLE = [
    "Descripción:",
    "Cantidad:",
    " - Talla:",
    "P.Unit:",
    "Desc:",
    "Importe:",
    "Vendedor:",
    "Origen:",
    "Abono:",
    "IVA abono:",
    "",
];
export const CAMPOS_DATOS = [
    { campo: "pc", etiqueta: "Caja", muestra: "CAJA 01" },
    { campo: "fechaventa", etiqueta: "Fecha", muestra: "17/10/2026 14:35" },
    { campo: "razonsocial", etiqueta: "Cliente", muestra: "Público en general" },
    { campo: "remision", etiqueta: "Folio venta", muestra: "1024" },
    // "Tipo de Pago" necesita mas ancho que el default de los campos (30 mm):
    // el valor ("EFECTIVO") debe caber junto a su etiqueta.
    { campo: "tipopago", etiqueta: "Tipo de Pago", muestra: "EFECTIVO", anchoMm: 50 },
    { campo: "usuario", etiqueta: "Operador", muestra: "Nadia" },
    { campo: "concepto", etiqueta: "Concepto", muestra: "Apartado de prueba" },
    { campo: "grupo", etiqueta: "Grupo", muestra: "GRUPO 1" },
];

export const LABELS_DATOS = [
    "Caja:",
    "Fecha:",
    "Cliente:",
    "Folio venta:",
    "Tipo de Pago:",
    "Operador:",
    "Concepto:",
    "Grupo:",
    "",
];

export const CAMPOS_TOTALES = [
    { campo: "subtotal", etiqueta: "Subtotal", muestra: "1,234.00" },
    { campo: "iva", etiqueta: "IVA", muestra: "123.40" },
    { campo: "total", etiqueta: "Total", muestra: "1,357.40" },
    { campo: "foliovale", etiqueta: "Folio Vale", muestra: "1024" },
    { campo: "montovale", etiqueta: "Descto Vale", muestra: "150.00" },
    { campo: "totaltipopago", etiqueta: "Total tipo pago", muestra: "1,357.40" },
    { campo: "totalefectivo", etiqueta: "Efectivo", muestra: "1,500.00" },
    { campo: "totalcambio", etiqueta: "Cambio", muestra: "142.60" },
    { campo: "totalarticulos", etiqueta: "Total articulos", muestra: "1,234.00" },
    { campo: "totalabonado", etiqueta: "Total abonado", muestra: "300.00" },
    { campo: "restante", etiqueta: "Restante", muestra: "934.00" },
    { campo: "totalenletra", etiqueta: "Total en letra", muestra: "TRESCIENTOS PESOS" },
];

export const LABELS_TOTALES = [
    "Subtotal:",
    "IVA:",
    "Total:",
    "Folio Vale:",
    "Descto Vale:",
    "Total tipo pago:",
    "Efectivo:",
    "Cambio:",
    "Total articulos:",
    "Total abonado:",
    "Restante:",
    "Total en letra:",
    "",
];

export const SEPARADORES = [
    { texto: "------------------------", vista: "-----" },
    { texto: "........................", vista: "....." },
    { texto: "- - - - - - - - - - - - - - -", vista: "- - -" },
];

export const dosDecimales = (n) => Math.round(n * 100) / 100;

// Las impresoras termicas trabaja con paginas de codigos de 8 bits (CP437/CP850):
// el texto UTF-8 llega con acentos rotos ("DescripciÂ¦n"). Para los tickets
// comerciales se transliteran los acentos a ASCII, que es lo que espera el
// papel y lo que espera el usuario.
const MAPA_ASCII = {
    "á": "a", "Ã ": "a", "Ã¤": "a", "Ã¢": "a", "Ã£": "a", "Ã¥": "a", "Á": "A", "Ã€": "A", "Ã„": "A", "Ã‚": "A", "Ãƒ": "A", "Ã…": "A",
    "é": "e", "Ã¨": "e", "Ã«": "e", "Ãª": "e", "É": "E", "Ãˆ": "E", "Ã‹": "E", "ÃŠ": "E",
    "í": "i", "Ã¬": "i", "Ã¯": "i", "Ã®": "i", "Í": "I", "ÃŒ": "I", "Ã": "I", "ÃŽ": "I",
    "ó": "o", "Ã²": "o", "Ã¶": "o", "Ã´": "o", "Ãµ": "o", "Ã“": "O", "Ã’": "O", "Ã–": "O", "Ã”": "O", "Ã•": "O",
    "ú": "u", "Ã¹": "u", "ü": "u", "Ã»": "u", "Ú": "U", "Ã™": "U", "Ü": "U", "Ã›": "U",
    "ñ": "n", "Ñ": "N", "Ã§": "c", "Ã‡": "C",
    "Â°": "o", "Âº": "o", "Âª": "a", "·": "-", "•": "-",
    "¡": "!", "¿": "?", "“": '"', "”": '"', "â€ž": '"', "Â«": '"', "Â»": '"',
    "â€˜": "'", "â€™": "'", "â€š": "'",
    "â€“": "-", "—": "-", "â€¦": "...", "â‚¬": "EUR", "â„¢": "(TM)", "Â®": "(R)",
};

export const transliterarTexto = (texto) => String(texto ?? "").replace(/[^\x00-\x7F]/g, (c) => MAPA_ASCII[c] ?? "?");

// Aplica la transliteracion a todos los textos de un objeto (datos del ticket).
export const transliterarObjeto = (valor) => {
    if (typeof valor === "string") return transliterarTexto(valor);
    if (Array.isArray(valor)) return valor.map((v) => transliterarObjeto(v));
    if (valor && typeof valor === "object") {
        const salida = {};
        Object.keys(valor).forEach((k) => { salida[k] = transliterarObjeto(valor[k]); });
        return salida;
    }
    return valor;
};

export const idDeObjeto = (o, i) => (o?.id ?? `det-auto-${i}`);

const buscarCampo = (campo, campos) => (campos || CAMPOS_DETALLE).find((c) => c.campo === campo);

export const esMultilineaObjeto = (o, campos = CAMPOS_DETALLE) => o?.tipo === "campo" && Boolean(buscarCampo(o?.campo, campos)?.multilinea);

export const anchoObjetoMm = (o, campos = CAMPOS_DETALLE) => Number(o?.anchoMm) || buscarCampo(o?.campo, campos)?.anchoMm || (o?.tipo === "label" ? 40 : 30);

// Ancho que el catalogo define para ese campo (o el default compartido).
export const anchoCatalogoMm = (o, campos = CAMPOS_DETALLE) => buscarCampo(o?.campo, campos)?.anchoMm || (o?.tipo === "label" ? 40 : 30);

export const altoObjetoMm = (o, campos = CAMPOS_DETALLE) => Number(o?.altoMm) || buscarCampo(o?.campo, campos)?.altoMm || 4;

export const normalizarObjetoDetalle = (o, i = 0, campos = CAMPOS_DETALLE) => ({
    id: idDeObjeto(o, i),
    tipo: o?.tipo === "campo" ? "campo" : "label",
    ...(o?.tipo === "campo" ? { campo: o?.campo ?? "" } : { texto: o?.texto ?? "" }),
    xMm: dosDecimales(Number(o?.xMm) || 0),
    yMm: dosDecimales(Number(o?.yMm) || 0),
    anchoMm: dosDecimales(anchoObjetoMm(o, campos)),
    altoMm: dosDecimales(altoObjetoMm(o, campos)),
    fuenteTipo: o?.fuenteTipo === "B" ? "B" : o?.fuenteTipo === "D" ? "D" : "A",
    negrita: Boolean(o?.negrita),
    alineacion: ["left", "center", "right"].includes(o?.alineacion) ? o.alineacion : "left",
    // Solo los campos multilinea (la descripcion) usan su ancho para el corte
    // de linea. El resto trabaja con ANCHO LIBRE: el texto fluye a la derecha y
    // el usuario ajusta la posicion (X) con libertad.
    multilinea: o?.tipo === "campo" ? esMultilineaObjeto(o, campos) : false,
    // La caja CRECE con el texto en vez de recortarlo.
    autoAlto: Boolean(o?.autoAlto),
});

const dinero = (valor) => "$" + (Number(valor) || 0).toFixed(2);

export const leerValeCabecero = (cabecero = {}) => ({
    folioVale: Number(cabecero.foliovaleporcambio ?? cabecero.FolioValePorCambio ?? cabecero.foliovale ?? 0) || 0,
    montoVale: Number(cabecero.montovaleporcambio ?? cabecero.MontoValePorCambio ?? cabecero.montovale ?? 0) || 0,
});

const soloTexto = (valor) => String(valor ?? "").trim();

export const formatearFechaVenta = (valor) => {
    const coincidencia = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(String(valor ?? ""));
    if (!coincidencia) return soloTexto(valor);
    return `${coincidencia[3]}/${coincidencia[2]}/${coincidencia[1]} ${coincidencia[4]}:${coincidencia[5]}`;
};

export const valorCampoDatos = (campo, cabecero = {}) => {
    switch (campo) {
        case "pc": return soloTexto(cabecero.pc);
        case "fechaventa": return formatearFechaVenta(cabecero.fechaventa);
        case "razonsocial": return soloTexto(cabecero.razonsocial) || "No especificado";
        case "remision": return soloTexto(cabecero.remision);
        case "tipopago": return soloTexto(cabecero.tipopago);
        case "usuario": return soloTexto(cabecero.usuario);
        case "concepto": return soloTexto(cabecero.concepto);
        case "grupo": return soloTexto(cabecero.grupo);
        default: return "";
    }
};

export const valorCampoDetalle = (campo, articulo = {}) => {
    switch (campo) {
        case "descripcion": return String(articulo.descripcion || "Sin descripción").trim();
        case "cantidad": return String(articulo.cantidad ?? 0).trim();
        case "medida": return String(articulo.medida ?? 0).trim();
        case "costounitario": return dinero(articulo.costounitario);
        case "descuento": return dinero(articulo.descuento);
        case "total": return dinero(articulo.total);
        case "vendedorpreventa": return String((articulo.vendedorpreventa || "").trim() || "N/A");
        case "almacenexhibidor": return String((articulo.almacenexhibidor || "").trim() || "N/A");
        case "abono": return dinero(articulo.abono);
        case "ivaabono": return dinero(articulo.ivaabono);
        default: return "";
    }
};

export const valorCampoTotales = (campo, cabecero = {}, opciones = {}) => {
    const tipoDocumento = opciones.tipoDocumento || "VENTA";
    const esVenta = tipoDocumento === "VENTA";
    const { folioVale, montoVale } = leerValeCabecero(cabecero);
    switch (campo) {
        case "subtotal": return dinero(cabecero.subtotal);
        case "iva": return dinero(cabecero.iva);
        case "total": return dinero(cabecero.total);
        case "foliovale": return (esVenta && folioVale > 0) ? String(folioVale) : "";
        case "montovale": return (esVenta && montoVale > 0) ? dinero(montoVale) : "";
        case "totaltipopago": return dinero(cabecero.totaltipopago);
        case "totalefectivo": return dinero(cabecero.totalefectivo);
        case "totalcambio": return dinero(cabecero.totalcambio);
        case "totalarticulos": return dinero(cabecero.totalarticulos);
        case "totalabonado": return dinero(cabecero.totalabonado);
        case "restante": return dinero(cabecero.restante);
        case "totalenletra": return soloTexto(cabecero.montoletra ?? cabecero.montoabonoletra);
        default: return "";
    }
};
